<template>

<div>
  <Row :gutter="20" type="flex" class="grid-list-row mx-0"
  :class="{'alert-list alert-red': transporterUserAvailable || (!isGateExist && ($router.currentRoute.name === 'Depot')) }">
    <Alert size="large" class="alert-md" :closable="false" v-if="transporterUserAvailable">
      <span v-if="currentSection === 'ndc_master'">{{$t('MDM_NDC_DOCUMENTS_PENDING')}}</span>
      <span v-else>{{$t('MDM_TRANSPORTER_USER_NOT_AVAILABLE')}}</span>
    </Alert>
    <Alert size="large" class="alert-md" :closable="false" v-if="!isGateExist && ($router.currentRoute.name === 'Depot')">
      <span>{{$t('MDM_GATES_NOT_AVAILABLE')}}</span>
    </Alert>
    <Col
      class="text-left"
      align="middle"
      v-for="(header,index) in headers"
      :key="index"
      v-if="canShowColumn(header)"
      :span="header.colSpan">
      <div @click="routeToDetails" class="full-width">
        <Row v-if="header.subColumnCount" class="full-width ">
          <Col
            align="middle"
            v-for="(header2,index) in header.subColumns"
            :key="index"
            :span="header2.colSpan">
              <div class="grid-content bg-purple-dark full-width" style="text-align:center">
                  <Ellipsis v-if="header2.truncateOn"
                    :text="data[header.column][header2.column].toString()"
                    :length="header2.truncateOn" />
                  <span v-else>{{data[header.column][header2.column]}}</span>
                </span>
              </div>
          </Col>
        </Row>
        <span v-else-if="header.label === 'exclude_vehicles_list'">
          <Popover placement="bottom-end" v-model="trucktype" popper-class="smpopover">
            <div class="popover-primary" v-if="data[header.label].length">
              <div class="popover-primary-header">
                <h3>{{$t('MDM_EXCLUDE_TRUCK_TYPE')}}</h3>
                <span class="remove-icon" @click="trucktype=false">
                  <svgicon name="cancel" width="10" height="10" :original="true" />
                </span>
              </div>
              <div class="popover-primary-body alignment scroll_section">
                <ul>
                  <li v-for="vehicle in data[header.label]" :key="vehicle.id">{{vehicle.name}}</li>
                </ul>
              </div>
            </div>
            <div slot="reference">
              <div class="countvalue">{{data[header.label].length}}</div>
            </div>
          </Popover>
        </span>
        <span v-else-if="data[header.column] && (header.type && !['link', 'date'].includes(header.type))">
          <WordList v-if="header.wordTruncateOn"
            :wordList="data[header.column]"
            :length="header.wordTruncateOn" />
          <Ellipsis v-else-if="header.truncateOn"
            :text="data[header.column].toString()"
            :length="header.truncateOn" />
          <span v-else>{{ data[header.column] }}</span>
        </span>
        <span v-else-if="header.type && header.type === 'downloadButton'">
          <Button type="secondary" size="mini" @click="downloadExcel(data.id)">{{$t('MDM_DOWNLOAD')}}</Button>
        </span>
        <span v-else-if="header.type && header.type === 'date'">

          <span>{{data[header.column] | moment("DD MMM YY HH : mm A") }}</span>
        </span>
        <span v-else-if="header.title === 'Status' && header.column === 'account_status'" :class="userStatusColorMappings[data[header.column]]">
          <WordList v-if="header.wordTruncateOn"
            :wordList="data[header.column]"
            :length="header.wordTruncateOn" />
          <Ellipsis v-else-if="header.truncateOn"
            :text="data[header.column].toString()"
            :length="header.truncateOn" />
          <span v-else>{{ data[header.column] }}</span>
        </span>
        <span v-else-if="header.title === 'Status'" :class="statusColorMappings[data[header.column]]">
          <WordList v-if="header.wordTruncateOn"
            :wordList="data[header.column]"
            :length="header.wordTruncateOn" />
          <Ellipsis v-else-if="header.truncateOn"
            :text="data[header.column].toString()"
            :length="header.truncateOn" />
          <span v-else>{{ data[header.column] }}</span>
        </span>
        <!--The below span class should be at last -->
        <span v-else-if="data[header.column]">
          <WordList v-if="header.wordTruncateOn"
            :wordList="data[header.column]"
            :length="header.wordTruncateOn" />
          <Ellipsis v-else-if="header.truncateOn"
            :text="data[header.column].toString()"
            :length="header.truncateOn" />
          <span v-else>{{ data[header.column] }}</span>
        </span>
        <span v-else>-</span>
      </div>
    </Col>
    <Col :span="actionSpan" align="middle" class="col-push text-right">
      <span class="link-action" v-if="showUpdate" @click="showUpdateSlider=true">
          <svgicon name="update" width="12" height="12" :original="true"/> {{$t('MDM_UPDATE')}}
      </span>
      <span class="link-action" v-if="showEdit" @click="edit">
          <svgicon name="edit" width="12" height="12" :original="true"/> {{$t('MDM_EDIT')}}
      </span>
      <span class="link-action" v-if="showDetails" @click="details">
          <svgicon name="details" width="12" height="12" :original="true"/> {{$t('MDM_DETAILS')}}
      </span>
      <span class="link-action" v-if="showTrash" @click="remove">
          <svgicon name="delete" width="12" height="12" :original="true"/> {{$t('MDM_DELETE')}}
      </span>
      <span class="link-action" v-if="showReject" @click="showReject">
           <Button type="secondary" size="mini" @click="reject(data)">{{$t('MDM_REJECT')}}</Button>
      </span>

      <span class="link-action" v-if="showApproval">
          <Button type="primary" size="mini" @click="approval(data)">{{$t('MDM_APPROVE')}}</Button>
      </span>
    </Col>
  </Row>

  <Drawer
    :visible.sync="showUpdateSlider"
    direction="rtl"
    size="440px"
    :modal="true"
    :withHeader="false"
    :append-to-body="true"
    class="default-drawer"
    v-if="showDepotAvailabilityDrawer"
  >
    <Link :underline="false" class="nav-close" @click="showUpdateSlider=false">
      <svgicon name="cancelwhite" width="12" height="12" :original="true" />
    </Link>
    <div class="drawer-header drawer-sub-title">
      {{ data.vehicles[0].number }}
      <div class="header-action">
        <Button type="text" class="text-primary" size="mini" @click="cancelAction">{{ $t('MDM_CANCEL') }}</Button>
        <Button type="primary" size="mini" @click="updateAction">{{ $t('MDM_UPDATE') }}</Button>
      </div>
    </div>
    <div class="drawer-body px-20 pt-0">
      <Table
        :data="localData && localData.vehicles && localData.vehicles.filter(v => v.depot_id)"
        class="table-striped bordered"
        aria-describedby="RowTableLocalData"
        >
        <TableColumn
          prop="depot_id.name"
          :label="$t('MDM_DEPOT')">
          <template slot-scope="scope">
            {{ scope.row.depot_id && scope.row.depot_id.name }}
          </template>
        </TableColumn>
        <TableColumn
          :label="$t('MDM_AVAILABILITY')"
          width="170">
          <template slot-scope="scope">
            <SwitchBtn
                v-model="scope.row.is_vehicle_available"
                label="right"
                size="small"
                active-text="YES"
                inactive-text="NO"
                class="default-switch">
            </SwitchBtn>
          </template>
        </TableColumn>
      </Table>
    </div>
  </Drawer>

</div>
</template>
<script>
import WordList from '@common/components/WordList';
import { maxColSpan } from '@common/constants/globalConstants';
import { cloneDeep } from 'lodash';
import { statusColorMappings } from '@common/constants/rateMatrixConstants';
import { statusColorMappings as userStatusColorMappings } from '@common/constants/mdmUserConstants';

export default {
  components: {
    WordList,
    maxColSpan,
  },
  props: ['headers', 'data', 'showUpdate','showEdit', 'showTrash', 'isRowClickable', 'showDepotAvailabilityDrawer',
    'showApproval', 'showReject', 'showDetails'],
  data() {
    return {
      statusColorMappings,
      userStatusColorMappings,
      availableStatus: true,
      showUpdateSlider: false,
      trucktype: false,
    };
  },
  computed: {
     isGateExist() {
      return (this.data && this.data.gates) && this.data.gates.length;
    },
    transporterUserAvailable() {
      return (!(this.data && this.data.isTransporterUserAvailable) && this.currentSection === 'transporter')
        || (this.currentSection === 'ndc_master' && this.data && !this.data.is_cndc_submitted && !this.data.is_ondc_submitted);
    },
    actionSpan() {
      return maxColSpan - this.headers.reduce((accumulator, header) => {
        if (this.canShowColumn(header)) {
          accumulator += parseFloat(header.colSpan);
        }
        return accumulator;
      }, 0);
    },
    tableData() {
      return this.data.all_depots;
    },
  },
  created() {
    this.currentSection = this.$router.history.current.name.toLowerCase();
    this.localData = cloneDeep(this.data);
  },
  methods: {
    canShowColumn(header) {
      return header.hasOwnProperty('show') ? header.show : true;
    },
    edit() {
      this.$emit('edit');
    },
    details() {
      this.$emit('details');
    },
    routeToDetails() {
      if (this.isRowClickable) {
        this.$emit('routeToDetails');
      }
    },
    remove() {
      this.$emit('remove');
    },
    approval(data) {
      this.$emit('approval', data);
    },
    reject(data) {
      this.$emit('reject', data);
    },
    downloadExcel(id) {
      this.$emit('downloadExcel', id);
    },
    cancelAction() {
      this.showUpdateSlider = false;
    },
    updateAction() {
      this.showUpdateSlider = false;
      this.$emit('update', this.localData );
    }
  },
};
</script>
